export default [
  // {
  //   name: 'department',
  //   path: '/department',
  //   meta: {},
  //   component: () => import(/* webpackChunkName: "department" */ './index.vue')
  // }
]
